/**
 * External File Search Agent - Suggestions Section
 * Section 3: Suggestions for best performance
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { EXTERNAL_FILE_SEARCH_PROMPT_KEYS } from './variables';
class ExternalFileSearchSuggestionsSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = EXTERNAL_FILE_SEARCH_PROMPT_KEYS.suggestions;
        this.fallbackContent = `## Best Practices

### Search Strategy Guidelines

**Vector Search** (semantic):
- Best for natural language queries
- Understands context and synonyms
- Example: "Find revenue growth projections" → may find "fiscal year income forecasts"

**Fuzzy Search** (approximate):
- Tolerates typos and variations
- Good for noisy/inconsistent text
- Example: "EBITDA" will find "EBIDTA" or "ebitda"

**Exact Search** (precise):
- Case-sensitive matching
- Best for legal/technical terms
- Example: "Section 409A" finds exact phrase only

### Excel Reading Tips
- Start with "structure" mode to understand the file layout
- Use "detailedValues" for specific data extraction (mind the cell limit)
- Use "formulaTrace" to understand calculated values

### Result Quality
- Search broadly first, then narrow down
- Include ALL relevant document IDs in searchResults
- Write clear rationale explaining what was found and where
- For Excel files, use readExcel with fileIndex to get detailed data when search results indicate relevant content`;
    }
}
const suggestionsSection = new ExternalFileSearchSuggestionsSection();
/**
 * Get the suggestions section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getSuggestionsSection() {
    return suggestionsSection.getContent();
}
/**
 * Export constant for backwards compatibility
 */
export const EXTERNAL_FILE_SUGGESTIONS = suggestionsSection.getFallbackContent();
